import NiceModal, { useModal } from "@ebay/nice-modal-react"
import { useState } from "react";
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Button from "../../UI/Button/Button";
import Field from "../../UI/Field/Field";
import TextInput from "../../UI/TextField/TextInput";
import { useForm } from "react-hook-form";
import './ApiModal.css'
const ApiModal = NiceModal.create(({ title, body, api, buttons, confirm, maxTitleSize =60 }) => {

    var sub_title = title
    if (title.length > maxTitleSize) {
        sub_title =title.substring(0,maxTitleSize);
        sub_title += '...';
    }

    const modal = useModal();
    const { onClose } = useModalHelper(modal);
    var { request, param } = api;

    const { handleSubmit } = useForm();

    //const [confirmDelete, setConfirmDelete] = useState(false);
    const [checkError, setCheckError] = useState("");
    const onSubmit = async () => {
        if (request == null) {
            modal.resolve(true);
            onClose();
        }

        if(confirm != null && Array.isArray(confirm.name)) {
            param = [...param, getValueConfirm(document.getElementById("confirm-delete").value)]
        }

        const [response, error] = await request(...param);
        if (error !== null) {
            onClose()
            modal.resolve(error);
            return
        }
        modal.resolve(response);
        onClose()
    };
    
    const isValueConfirm = (value) => {
        if(Array.isArray(confirm.name)) {
            return confirm.name.filter(data => data.value == value).length > 0;
        }
        
        return value == confirm.name;
    }

    const getValueConfirm = (value) => {
        if(Array.isArray(confirm.name)) {
            const data = confirm.name.filter(data => data.value == value).pop();
            return data.id ? data.id : data.value;
        }
        return confirm.name;
    }

    const checkConfirm = () => {
        if (confirm != null && isValueConfirm(document.getElementById("confirm-delete").value) == false) {
            setCheckError(true)
            return;
        }
        onSubmit()
    }

    const haveToConfirm = (props) => {
        if (props != null && confirm != null){
            return props.type == 'submit';
        }
        return false;
    }

    return (
        <Modal name="logout" id={modal.id} onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({ idIconModal: "close_modal_container" })} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="modal-form" onSubmit={handleSubmit(checkConfirm)}>

                <Form.Title>{sub_title}</Form.Title>
                <Form.Body><p>{body}</p></Form.Body>
                <div>
                {
                        confirm != null ?
                            <div>
                                <div>
                                    <Field label={"Tap the name of " + confirm.fieldName}></Field>
                                    <TextInput style={{ marginBottom: "15px", borderColor: checkError === false? 'var(--pink)' :''  }} id="confirm-delete" onKeyDown={(e) => e.keyCode == 13 ? e.preventDefault() : null} onChange={(e)=>  setCheckError(isValueConfirm(e.target.value)) }></TextInput>
                                </div>
                                { 
                                /*
                                <Form.Buttons className="center_confirmButton">
                                    <Button disabled={!checkError} label="Confirm" style={{ margin: 10 }} onClick={() => checkConfirm()} />
                                </Form.Buttons>
                                */
                                
                                    }

                            </div>

                            :
                            null
                    }
                    <div style={{ display: 'flex' }}>

                        {buttons && buttons.map((props, index) =>
                            <>
                                <Button  {...props} disabled={ haveToConfirm(props) ? !checkError : false} style={{ margin: 10 }} onClick={() => haveToConfirm() ? checkConfirm() : (props.type != "submit" ? onClose() : "") } key={"btn-" + index} />
                            </>
                        )}

                    </div>
                </div>
            </Form>

        </Modal>
    )
});

ApiModal.defaultProps = {
    api: { request: null, param: [] },
    buttons: [
        { className: 'validate', label: 'Back' },
        { className: 'cancel', label: 'Leave', type: 'submit' },
    ]
}

export default ApiModal;